
const Menu = () => {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="path-1-inside-1_233_70724" fill="white">
<path d="M0 0.269531H20V13.2695H0V0.269531Z"/>
</mask>
<path d="M20 12.2695H0V14.2695H20V12.2695Z" fill="#0C0C0C" mask="url(#path-1-inside-1_233_70724)"/>
<rect y="0.269531" width="20" height="1" rx="0.5" fill="#0C0C0C"/>
<rect y="6.26953" width="20" height="1" rx="0.5" fill="#0C0C0C"/>
</svg>

  )
}

export default Menu